import { memo } from 'react';

import { type CardSize } from '@air/api/types';
import { ChevronDown } from '@air/next-icons';
import { input } from '@air/primitive-input';

import { useCardSizePreference } from '~/hooks/useCardSizePreference';

const cardSizes: { label: string; value: CardSize }[] = [
  { label: 'Small', value: 'small' },
  { label: 'Medium', value: 'medium' },
  { label: 'Large', value: 'large' },
  { label: 'Extra Large', value: 'extra-large' },
];

export const ViewCardSizePreference = memo(() => {
  const { cardSize, updateCardSize } = useCardSizePreference();

  return (
    <>
      <div className="flex items-center justify-between gap-6 px-1.5 py-1">
        <label className="text-14" htmlFor="preferences">
          Size
        </label>
        <div className={input({ className: 'relative px-0 text-12', size: 'small' })}>
          <select
            id="cardSize"
            defaultValue={cardSize}
            className="size-full cursor-pointer appearance-none bg-transparent pr-8 pl-2"
            onChange={(event) => {
              updateCardSize(event.target.value as CardSize);
            }}
            value={cardSize}
          >
            {cardSizes.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
          <ChevronDown className="pointer-events-none absolute top-1/2 right-2 size-4 -translate-y-1/2" />
        </div>
      </div>
    </>
  );
});

ViewCardSizePreference.displayName = 'ViewCardSizePreference';
